
import { useEffect, useState } from "react";
import { useEmailDraftsManagement } from "@/hooks/useEmailDraftsManagement";
import { useInvestorProcessing } from "@/hooks/useInvestorProcessing";
import DraftsList from "@/components/emails/DraftsList";
import DraftDetailsEditor from "@/components/emails/DraftDetailsEditor";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

const EmailDrafts = () => {
  const { investors, contacts, loadSavedData } = useInvestorProcessing();
  const [dataLoaded, setDataLoaded] = useState(false);

  const {
    drafts,
    selectedDraft,
    isLoading,
    loadDrafts,
    handleViewDraft,
    handleCloseDraftDetails,
    handleDraftUpdated,
    handleDeleteDraft,
    handleMarkAsSent
  } = useEmailDraftsManagement();

  // Load data only once on initial mount
  useEffect(() => {
    if (!dataLoaded) {
      Promise.all([
        loadSavedData(),
        loadDrafts()
      ]).then(() => {
        setDataLoaded(true);
      });
    }
  }, [loadSavedData, loadDrafts, dataLoaded]);

  // Get draft related data
  const getDraftRelatedData = () => {
    if (!selectedDraft) return { investor: undefined, contact: undefined };
    
    const investor = investors.find(inv => inv.id === selectedDraft.investorId);
    const contact = contacts.find(c => c.id === selectedDraft.contactId);
    
    return { investor, contact };
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Email Drafts</h1>

      <Card>
        <CardHeader>
          <CardTitle>Email Drafts</CardTitle>
          <CardDescription>
            Edit and manage your saved email drafts
          </CardDescription>
        </CardHeader>
        <CardContent>
          {selectedDraft ? (
            <DraftDetailsEditor 
              draft={selectedDraft}
              investor={getDraftRelatedData().investor}
              contact={getDraftRelatedData().contact}
              onClose={handleCloseDraftDetails}
              onUpdate={handleDraftUpdated}
              onDelete={handleDeleteDraft}
              onMarkAsSent={handleMarkAsSent}
            />
          ) : (
            <DraftsList 
              drafts={drafts}
              investors={investors}
              contacts={contacts}
              onViewDraft={handleViewDraft}
              onDeleteDraft={handleDeleteDraft}
              onMarkAsSent={handleMarkAsSent}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailDrafts;
